/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FufiInvestmentItem } from './FufiInvestmentItem';
import {
    FufiInvestmentItemFromJSON,
    FufiInvestmentItemFromJSONTyped,
    FufiInvestmentItemToJSON,
    FufiInvestmentItemToJSONTyped,
} from './FufiInvestmentItem';
import type { FufiContractSavingsDto } from './FufiContractSavingsDto';
import {
    FufiContractSavingsDtoFromJSON,
    FufiContractSavingsDtoFromJSONTyped,
    FufiContractSavingsDtoToJSON,
    FufiContractSavingsDtoToJSONTyped,
} from './FufiContractSavingsDto';
import type { FufiAllocationRateItem } from './FufiAllocationRateItem';
import {
    FufiAllocationRateItemFromJSON,
    FufiAllocationRateItemFromJSONTyped,
    FufiAllocationRateItemToJSON,
    FufiAllocationRateItemToJSONTyped,
} from './FufiAllocationRateItem';

/**
 * 
 * @export
 * @interface GetFufiInvestmentsResponse
 */
export interface GetFufiInvestmentsResponse {
    /**
     * 
     * @type {Array<FufiInvestmentItem>}
     * @memberof GetFufiInvestmentsResponse
     */
    investments: Array<FufiInvestmentItem>;
    /**
     * 
     * @type {Array<FufiAllocationRateItem>}
     * @memberof GetFufiInvestmentsResponse
     */
    allocationRatio: Array<FufiAllocationRateItem>;
    /**
     * 
     * @type {FufiContractSavingsDto}
     * @memberof GetFufiInvestmentsResponse
     */
    contractSavings: FufiContractSavingsDto;
}

/**
 * Check if a given object implements the GetFufiInvestmentsResponse interface.
 */
export function instanceOfGetFufiInvestmentsResponse(value: object): value is GetFufiInvestmentsResponse {
    if (!('investments' in value) || value['investments'] === undefined) return false;
    if (!('allocationRatio' in value) || value['allocationRatio'] === undefined) return false;
    if (!('contractSavings' in value) || value['contractSavings'] === undefined) return false;
    return true;
}

export function GetFufiInvestmentsResponseFromJSON(json: any): GetFufiInvestmentsResponse {
    return GetFufiInvestmentsResponseFromJSONTyped(json, false);
}

export function GetFufiInvestmentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFufiInvestmentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'investments': ((json['investments'] as Array<any>).map(FufiInvestmentItemFromJSON)),
        'allocationRatio': ((json['allocationRatio'] as Array<any>).map(FufiAllocationRateItemFromJSON)),
        'contractSavings': FufiContractSavingsDtoFromJSON(json['contractSavings']),
    };
}

export function GetFufiInvestmentsResponseToJSON(json: any): GetFufiInvestmentsResponse {
    return GetFufiInvestmentsResponseToJSONTyped(json, false);
}

export function GetFufiInvestmentsResponseToJSONTyped(value?: GetFufiInvestmentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investments': ((value['investments'] as Array<any>).map(FufiInvestmentItemToJSON)),
        'allocationRatio': ((value['allocationRatio'] as Array<any>).map(FufiAllocationRateItemToJSON)),
        'contractSavings': FufiContractSavingsDtoToJSON(value['contractSavings']),
    };
}

